toastr.options = {
  "positionClass": "toast-top-center"
};
